/**
 * Configurações de Ambiente
 * Centraliza a detecção de plataforma e URLs da API.
 */

// Detecção segura de ambiente nativo (Capacitor)
import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();

// Verificação de Produção
const isProduction = process.env.NODE_ENV === 'production';

// URL da API REST
// No Capacitor, URLs relativas (/api) não funcionam.
// Em produção nativa, a URL DEVE ser fornecida via variável de ambiente.
const getBaseUrl = (): string => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;

  if (isNative) {
    if (isProduction) {
      // Bloqueio de segurança: impede que builds de produção usem localhost acidentalmente
      console.error('[ERRO] Build de produção nativo detetado sem REACT_APP_API_URL definida.');
      return 'https://akzicao.com/api'; // Fallback conceitual seguro (HTTPS)
    }
    return 'http://localhost:3001/api';
  }

  return isProduction ? '/api' : 'http://localhost:3001/api';
};

export const API_BASE_URL = getBaseUrl();

// URL do Socket.IO
const getSocketUrl = (): string => {
  if (process.env.REACT_APP_SOCKET_URL) return process.env.REACT_APP_SOCKET_URL;

  if (isNative) {
    if (isProduction) {
      console.error('[ERRO] Build de produção nativo detetado sem REACT_APP_SOCKET_URL definida.');
      return 'https://akzicao.com/notificacoes';
    }
    return 'http://localhost:3001/notificacoes';
  }

  return isProduction
    ? `${window.location.origin}/notificacoes`
    : 'http://localhost:3001/notificacoes';
};

export const SOCKET_BASE_URL = getSocketUrl();



